module.exports = __webpack_public_path__ + "img/Oscar_Barajas.1a0a807e.jpg";